import { useEffect } from "react";
import { useSelector } from "react-redux";
import { openModal } from "risa-oasis-ui_v2";
import { ModalId } from "../../../../enums/modalId";
import { RootState } from "../../../../redux/store/store";

/**
 * Synchronizes Redux modal state with the Oasis UI modal system.
 * Watches for changes to `openedModalId` in the Redux store and triggers
 * the corresponding Oasis UI `openModal` call for supported modal types.
 *
 * @returns The currently opened modal ID and associated metadata from Redux
 */
export const useModalOpenerForMedicalPaOrders = () => {
  const { openedModalId, metaData } = useSelector(
    (state: RootState) => state.modal,
  );

  useEffect(() => {
    if (openedModalId === ModalId.IMAGE_VIEWER_MODAL) {
      openModal(ModalId.IMAGE_VIEWER_MODAL);
    }
    if (openedModalId === ModalId.DOC_VIEWER_WITH_SIDE_NAVIGATION) {
      openModal(ModalId.DOC_VIEWER_WITH_SIDE_NAVIGATION);
    }
    if (openedModalId === ModalId.ANALYTICS_DATE_PICKER_MODAL) {
      openModal(ModalId.ANALYTICS_DATE_PICKER_MODAL);
    }
    if (openedModalId === ModalId.IMAGE_VIEWER_WITH_BADGES_MODAL) {
      openModal(ModalId.IMAGE_VIEWER_WITH_BADGES_MODAL);
    }
    if (openedModalId === ModalId.ORDER_PROCESSING_INFO_MODAL) {
      openModal(ModalId.ORDER_PROCESSING_INFO_MODAL);
    }
    if (openedModalId === ModalId.VIEW_REVIEW_MODAL) {
      openModal(ModalId.VIEW_REVIEW_MODAL);
    }
    if (openedModalId === ModalId.DOCUMENT_SCREENSHOT_VIEWER_MODAL) {
      openModal(ModalId.DOCUMENT_SCREENSHOT_VIEWER_MODAL);
    }
    if (openedModalId === ModalId.BULK_REASSIGN_MODAL) {
      openModal(ModalId.BULK_REASSIGN_MODAL);
    }
    if (openedModalId === ModalId.RADIO_SELECT_MODAL) {
      openModal(ModalId.RADIO_SELECT_MODAL);
    }
  }, [openedModalId]);

  return { openedModalId, metaData };
};
